var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "yahome-footer", staticStyle: { cursor: "default" } },
      [
        _c(
          "a",
          { attrs: { href: "https://www.asecl.com.tw/", target: "_blank" } },
          [_vm._v("ASECL-Recruit")]
        ),
        _vm._v(" © " + _vm._s(new Date().getFullYear()) + " "),
        _c(
          "a",
          { attrs: { href: `${_vm.url}/#/privacy_policy`, target: "_blank" } },
          [_vm._v("Privacy Policy")]
        ),
        _vm.page === "HomePage"
          ? [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  staticStyle: {
                    position: "absolute",
                    right: "10px",
                    top: "0.2px",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-right": "5px",
                        "vertical-align": "middle",
                      },
                    },
                    [_vm._v("v1.010")]
                  ),
                  _c("eva-icon", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      name: "bell-outline",
                      fill: "#FFF",
                      width: "18px",
                      height: "18px",
                      "data-toggle": "modal",
                      "data-target": "#delModal",
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "delModal", tabindex: "-1" } },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [_vm._v("版更紀錄")]),
              _c("div", { staticClass: "modal-body" }, [
                _c("strong", [_vm._v(" v1.010")]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-success" }, [
                    _vm._v("新增功能"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " 人才庫 | 新增檢視履歷按鈕，使用者除了觀看歷程外也可直接觀看履歷。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 填寫履歷 | 學校、科系、語言增加其他選項，供使用者輸入。"
                  ),
                  _c("br"),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-primary" }, [
                    _vm._v("優化項目"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(" 登入權限 | 修改權限簽章資訊。"),
                  _c("br"),
                  _vm._v(" 需求單 | 已結案需求單移除招募期限的日期卡控。"),
                  _c("br"),
                  _vm._v(" 組織管理 | 人員查詢增加 EMAIL 搜尋條件。"),
                  _c("br"),
                  _vm._v(
                    " 報到通知範本 | 新增時間參數，供發送信件時參數使用。"
                  ),
                  _c("br"),
                  _vm._v(" 報到查詢 | 新增報到時間搜尋條件。"),
                  _c("br"),
                  _vm._v(" 招聘進度 | 邀約面談，增加招募期限查詢條件。"),
                  _c("br"),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-warning" }, [
                    _vm._v("修正程式"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(" 人才庫 | 修正查詢結果，分頁異常問題。"),
                  _c("br"),
                  _vm._v(" 系統選單 | 修改自動收合功能，改為單獨展開及收合。"),
                  _c("br"),
                  _vm._v(" 組織管理 | 修正部門裡有人員卻可以刪除部門之問題。"),
                  _c("br"),
                  _vm._v(
                    " 組織管理 | 修正人員匯入，是否為部門主管無法正常顯示之問題。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 面談邀約 | 修正面談地點輸入過多文字無法送出之問題。"
                  ),
                  _c("br"),
                  _vm._v(" 首頁 | 修正職缺列表切換分頁功能。"),
                  _c("br"),
                  _vm._v(" 履歷填寫 | 修正大頭照無緩存之問題。"),
                  _c("br"),
                  _vm._v(" 人事資料表 | 修正畫面無法滾動之問題。"),
                  _c("br"),
                  _vm._v(" 需求單查詢 | 修正搜尋結果與搜尋筆數異常之問題。"),
                  _c("br"),
                ]),
                _c("hr", {
                  staticClass: "mt-4",
                  staticStyle: { "border-top": "1px dashed #808080" },
                }),
                _c("strong", [_vm._v(" v1.009")]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-success" }, [
                    _vm._v("新增功能"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(" 語系維護 | 新增維護頁面。"),
                  _c("br"),
                  _vm._v(
                    " 選單多國 | 新增選單多國語系、供使用者自定義對應顯示文字。"
                  ),
                  _c("br"),
                  _vm._v(
                    " RPA模組 | 新增同步履歷設定功能(排程、信件參數)、同步紀錄。"
                  ),
                  _c("br"),
                  _vm._v(" 飛騰串接模組 | 面談結果串接至飛騰系統進行簽核。"),
                  _c("br"),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-primary" }, [
                    _vm._v("優化項目"),
                  ]),
                ]),
                _c("p", [_vm._v("需求申請 | 科系選擇增加搜尋功能。")]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-warning" }, [
                    _vm._v("修正程式"),
                  ]),
                ]),
                _c("p", [
                  _vm._v("飛騰串接模組 | 修正任用單送出至飛騰的表單名稱。"),
                ]),
                _c("hr", {
                  staticClass: "mt-4",
                  staticStyle: { "border-top": "1px dashed #808080" },
                }),
                _c("strong", [_vm._v(" v1.008")]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-success" }, [
                    _vm._v("新增功能"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    "填寫履歷 | 同步104履歷功能(登入104帳號自動將履歷匯入)。"
                  ),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-primary" }, [
                    _vm._v("優化項目"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " 履歷欄位 | 新增專長頁籤，國家、婚姻狀態、特殊身分、兵役狀態、血型、學校、學制、語言、方言、語言程度、證照、駕照、專長特色之資料來源，可由資料庫維護。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 需求申請 | 新增職務聯絡人資訊，招募方式、工作時間、薪資類型、學歷、科系、外語、方言、語言程度、駕照、證照之資料來源，可由資料庫維護。"
                  ),
                  _c("br"),
                  _vm._v(" 任用結果 | 錄取通知信可一併發送Offer範本。"),
                  _c("br"),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-warning" }, [
                    _vm._v("修正程式"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " 觀看履歷 | 修正匯出履歷PDF，部份欄位如果沒有資料會無法匯出的問題。"
                  ),
                  _c("br"),
                ]),
                _c("hr", {
                  staticClass: "mt-4",
                  staticStyle: { "border-top": "1px dashed #808080" },
                }),
                _c("strong", [_vm._v(" v1.007")]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-success" }, [
                    _vm._v("新增功能"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " 面談紀錄 | 完成評估功能增加備註欄位(非必填)，選擇評估結果時可一併輸入備註。 "
                  ),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-primary" }, [
                    _vm._v("優化項目"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(" 系統設定 | 後台自動登出時間改為可在資料庫中調整。"),
                  _c("br"),
                  _vm._v(
                    " 需求查詢 | 列表上增加顯示當前簽核者，如已簽核完畢則顯示最後一位簽核者。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 需求申請 | 列表上增加顯示當前簽核者，如已簽核完畢則顯示最後一位簽核者。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 任用結果 | 列表上增加顯示當前簽核者，如已簽核完畢則顯示最後一位簽核者。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 職缺管理 | 履歷數量、面談結果列表上增加顯示是否已發送感謝函，如果已發送過，再次發送前跳出提示。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 招聘進度 | 邀約面談、面談結果列表上增加顯示是否已發送感謝函，如果已發送過，再次發送前跳出提示。 "
                  ),
                ]),
                _c("h5", [
                  _c("span", { staticClass: "badge badge-warning" }, [
                    _vm._v("修正程式"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " 招聘進度 | 單位主管使用的各功能，移除部門篩選條件。"
                  ),
                  _c("br"),
                  _vm._v(" 參數設定 | 調整參數名稱與排序。"),
                  _c("br"),
                  _vm._v(" 各功能 | 列表功能分頁方式調整。 "),
                ]),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 關閉 ")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }